import {Injectable, OnDestroy} from '@angular/core';
import {ProcessReport} from "../../model/reports.model";
import {ReportsManagerService} from "../../services/reports-manager.service";
import {SessionManagerService} from "../../services/session-manager.service";
import {ViewManagerService} from "../../services/view-manager.service";
import {Level, Message} from "../../model/message.component";
import {BehaviorSubject} from "rxjs";
import {PipelineState} from "../../model/machine.model";

@Injectable({
  providedIn: 'root'
})
export class DashboardService implements OnDestroy {

  statuses: ProcessReport[]
  reports: ProcessReport[]

  statusesSubject = new BehaviorSubject<ProcessReport[]>([]);

  constructor(
    private reportsManager: ReportsManagerService,
    private sessionManager: SessionManagerService,
    private viewManager: ViewManagerService
  ) {
  }

  ngOnDestroy() {
    this.stop()
  }

  stop(): void {
    this.statuses = [];
    this.reports = [];
    this.statusesSubject.next([]);
  }

  init() {
    let space = this.sessionManager?.session?.space ?? ""
    this.reportsManager.loadStatuses(space)
      .pipe()
      .subscribe({
        next: (result) => {
          this.statuses = result;
          this.statusesSubject.next(result);
        },
        error: error => {
          this.statusesSubject.next([]);
          this.viewManager.displayMessage(new Message(error.error, new Level("error")))
        }
      });
  }

  reset() {
    this.stop();
    this.init();
  }

  report(process: ProcessReport) {
    let owner = process.owner ?? ""
    let vertical = process.vertical ?? ""
    let code = process.code ?? ""
    this.reportsManager.loadReports(owner, vertical, code)
      .pipe()
      .subscribe({
        next: (result) => {
          this.reports = result;
          this.statusesSubject.next(result);
        },
        error: error => {
          this.statusesSubject.next([]);
          this.viewManager.displayMessage(new Message(error.error, new Level("error")))
        }
      });
  }

}
